<template>
  <a-spin :spinning="loading" :tip="loadTip">
    <a-form>
      <a-row>
        <a-col span="9">
          <a-form-item :colon="false" label="主症" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                       :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
            <a-select show-search v-model="search.symptom" placeholder="请选择/输入主症" @select="autoCompleteSymptomSelect"
                      @search="value => autoCompleteMainSymptomSearch(value)" :filter-option="false"
                      option-label-prop="label" :dropdown-match-select-width="false"
                      :dropdown-class-name="(undefined != symptoms && null != symptoms && symptoms.length > 0)?'gpws-select-dropdown':'gpws-main-select-dropdown'">
              <template v-if="(undefined != symptoms && null != symptoms && symptoms.length > 0)">
                <a-select-option v-for="item in symptoms" :key="item.id" :value="item.id" :label="item.name">
                  <a-row>
                    <a-col span="8" style="color:rgba(44, 158, 21, 1);font-weight: 400;">
                      {{ item.name }}
                    </a-col>
                    <a-col span="16">
                      {{ item.initial }} &nbsp; {{ item.full }}
                      <template v-if="(undefined != item.alias && null != item.alias && item.alias.length > 0)">
                        <template v-for="e in item.alias">
                          &nbsp;{{ e }}
                        </template>
                      </template>
                    </a-col>
                  </a-row>
                </a-select-option>
              </template>
              <template v-else>
                <a-select-opt-group v-for="(item, index) in symptomTrees" :key="'d-'+(index + 1)" :label="item.name">
                  <a-select-option v-for="e in item.children" :key="e.id" :value="e.id" :label="e.name">
                    <a-tooltip v-if="(undefined != e.alias && null != e.alias && e.alias.length > 0)"
                               placement="rightTop">
                      <template slot="title">
                        {{ e.alias.join('/') }}
                      </template>
                      <span style="cursor: pointer;">{{ e.name }}</span>
                    </a-tooltip>
                    <span v-else style="cursor: pointer;">{{ e.name }}</span>
                  </a-select-option>
                </a-select-opt-group>
              </template>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :colon="false" label="症状" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }"
                       :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }" style="padding-right: 10px" >
            <a-select mode="multiple" :filter-option="false" v-model="search.symptoms" placeholder="请输入症状名"
                      @search="value => autoCompleteSymptomSearch(value)" @deselect="autoCompleteSymptomDeselect"
                      option-label-prop="label" :dropdown-match-select-width="false"
                      :dropdown-class-name="(undefined != symptoms && null != symptoms && symptoms.length > 0)?'gpws-select-dropdown':'gpws-main-select-dropdown'">
              <template>
                <a-select-option v-for="item in (symptoms||[])" :key="item.id" :value="item.id" :label="item.name">
                  <a-row>
                    <a-col span="8" style="color:rgba(44, 158, 21, 1);font-weight: 400;">
                      {{ item.name }}
                    </a-col>
                    <a-col span="16">
                      {{ item.initial }} &nbsp; {{ item.full }}
                      <template v-if="(undefined != item.alias && null != item.alias && item.alias.length > 0)">
                        <template v-for="e in item.alias">
                          &nbsp;{{ e }}
                        </template>
                      </template>
                    </a-col>
                  </a-row>
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="3" style="text-align: left;">
          <img src="../../assets/img/s-search.png"
               style="user-select: none;cursor: pointer;margin-right: 10px;margin-top: 4px;"
               @click="symptomSearchAction"/>
          <img src="../../assets/img/s-clear.png" style="user-select: none;cursor: pointer;margin-top: 4px;"
               @click="symptomSearchClear"/>
        </a-col>
      </a-row>
    </a-form>
    <a-row>
      <a-col span="16" style="border: 1px solid rgba(232, 232, 232, 1);">
        <a-row>
          <a-col span="24"
                 style="padding-left: 30px;padding-top: 4px;padding-bottom: 4px;border-bottom: 1px solid rgba(232, 232, 232, 1);">
            <a-button-group shape="round">
              <a-button size="default"
                        :class="(init.symptomType =='GENERAL'?'gpws-symptom-left-active':'gpws-symptom-left-btn')"
                        @click="symptomTypeChange('GENERAL')">一般症状
              </a-button>
              <a-button size="default"
                        :class="(init.symptomType =='GLOSSOSCOPY'?'gpws-symptom-active':'gpws-symptom-btn')"
                        @click="symptomTypeChange('GLOSSOSCOPY')">舌诊
              </a-button>
              <a-button size="default"
                        :class="(init.symptomType =='PULSE'?'gpws-symptom-right-active':'gpws-symptom-right-btn')"
                        @click="symptomTypeChange('PULSE')">脉诊
              </a-button>
            </a-button-group>
          </a-col>
        </a-row>
        <a-row>
          <a-col span="24" style="height: 250px;overflow-y: auto;">
            <a-row :style="{'display':(init.symptomType =='GENERAL'?'block':'none')}">
              <a-col>
                <template v-if="(undefined != trees && null != trees && trees.length > 0)">
                  <template
                      v-for="(item, index) in trees.filter(m => ((m.children||[]).length > 0 && m.children.filter(n => n.type == 'GENERAL').length > 0))">
                    <a-row :style="{'background':(index%2 == 0?'rgba(232, 232, 232, 0.2)':'#ffffff')}">
                      <a-col span="2" class="gpws-symptom-postion">
                        {{ item.name }}
                      </a-col>
                      <a-col span="22" style="border-left: 1px solid #e8e8e8!important;line-height: 40px !important;">
                        <a-row style="line-height: 40px !important;text-align: center !important;">
                          <template v-for="(e, i) in item.children">
                            <template
                                v-if="e.type == 'GENERAL' && presSymptoms.includes(e.id) && !conflicts.includes(e.id)">
                              <a-col span="4" style="line-height: 40px!important;text-align: center!important;">
                                <a-tooltip v-if="(undefined != e.alias && null != e.alias && e.alias.length > 0)"
                                           placement="rightTop">
                                  <template slot="title">
                                    {{ e.alias.join('/') }}
                                  </template>
                                  <span
                                      :class="'gpws-symptom-span'+(search.subSymptoms.includes(e.id)?' gpws-symptom-span-selected':'')"
                                      @click="symptomClickAction(e.id)">{{ e.name }}</span>
                                </a-tooltip>
                                <span v-else
                                      :class="'gpws-symptom-span'+(search.subSymptoms.includes(e.id)?' gpws-symptom-span-selected':'')"
                                      @click="symptomClickAction(e.id)">{{ e.name }}</span>
                              </a-col>
                            </template>
                          </template>
                        </a-row>
                      </a-col>
                    </a-row>
                  </template>
                </template>
              </a-col>
            </a-row>
            <a-row :style="{'display':(init.symptomType =='GLOSSOSCOPY'?'block':'none')}">
              <a-col>
                <template v-if="(undefined != trees && null != trees && trees.length > 0)">
                  <template
                      v-if="trees.filter(m => ((m.children||[]).length > 0 && m.children.filter(n => n.type == 'GLOSSOSCOPY').length > 0)).length > 0">
                    <a-row>
                      <template
                          v-for="(item, index) in trees.filter(m => ((m.children||[]).length > 0 && m.children.filter(n => n.type == 'GLOSSOSCOPY').length > 0))">
                        <template v-for="(e, i) in item.children">
                          <template
                              v-if="e.type == 'GLOSSOSCOPY' && presSymptoms.includes(e.id) && !conflicts.includes(e.id)">
                            <a-col span="4" style="line-height: 40px!important;text-align: center!important;">
                              <a-tooltip v-if="(undefined != e.alias && null != e.alias && e.alias.length > 0)"
                                         placement="rightTop">
                                <template slot="title">
                                  {{ e.alias.join('/') }}
                                </template>
                                <span
                                    :class="'gpws-symptom-span'+(search.subSymptoms.includes(e.id)?' gpws-symptom-span-selected':'')"
                                    @click="symptomClickAction(e.id)">{{ e.name }}</span>
                              </a-tooltip>
                              <span v-else
                                    :class="'gpws-symptom-span'+(search.subSymptoms.includes(e.id)?' gpws-symptom-span-selected':'')"
                                    @click="symptomClickAction(e.id)">{{ e.name }}</span>
                            </a-col>
                          </template>
                        </template>
                      </template>
                    </a-row>
                  </template>
                </template>
              </a-col>
            </a-row>
            <a-row :style="{'display':(init.symptomType =='PULSE'?'block':'none')}">
              <a-col>
                <template v-if="(undefined != trees && null != trees && trees.length > 0)">
                  <template
                      v-if="trees.filter(m => ((m.children||[]).length > 0 && m.children.filter(n => n.type == 'PULSE').length > 0)).length > 0">
                    <a-row>
                      <template
                          v-for="(item, index) in trees.filter(m => ((m.children||[]).length > 0 && m.children.filter(n => n.type == 'PULSE').length > 0))">
                        <template v-for="(e, i) in item.children">
                          <template
                              v-if="e.type == 'PULSE' && presSymptoms.includes(e.id) && !conflicts.includes(e.id)">
                            <a-col span="4" style="line-height: 40px!important;text-align: center!important;">
                              <a-tooltip v-if="(undefined != e.alias && null != e.alias && e.alias.length > 0)"
                                         placement="rightTop">
                                <template slot="title">
                                  {{ e.alias.join('/') }}
                                </template>
                                <span
                                    :class="'gpws-symptom-span'+(search.subSymptoms.includes(e.id)?' gpws-symptom-span-selected':'')"
                                    @click="symptomClickAction(e.id)">{{ e.name }}</span>
                              </a-tooltip>
                              <span v-else
                                    :class="'gpws-symptom-span'+(search.subSymptoms.includes(e.id)?' gpws-symptom-span-selected':'')"
                                    @click="symptomClickAction(e.id)">{{ e.name }}</span>
                            </a-col>
                          </template>
                        </template>
                      </template>
                    </a-row>
                  </template>
                </template>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="border: 1px solid rgba(232, 232, 232, 1);">
        <a-row>
          <a-col span="24" style="border-bottom: 1px solid rgba(232, 232, 232, 1);">
            <span
                style="line-height:45px; min-width:100px;text-align: center;padding: 12px;border-bottom: 2px solid rgba(208, 47, 47, 1);">症状描述</span>
          </a-col>
        </a-row>
        <a-row style="height: 250px;overflow: hidden;">
          <a-col span="12">
            <a-row>
              <a-col span="24"
                     style="font-family: Alibaba PuHuiTi!important;font-weight: 400!important;line-height: 40px;text-align: center;">
                {{ (symptom || {name: ''}).name }}
              </a-col>
            </a-row>
            <a-row>
              <a-col span="24" style="line-height: 18px;padding: 4px;">
                &nbsp;&nbsp;{{ (symptom || {explain: ''}).explain }}
              </a-col>
            </a-row>
          </a-col>
          <a-col span="12">
            <img v-if="((symptom||{pic:''}).pic||'') != ''" :src="symptom.pic"
                 style="margin-top: 50px;width: 190px; height: 190px;border-radius: 10px;"  @click="showFullImg(symptom.pic)">
            <span v-else>&nbsp;</span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row>
      <a-col span="24" style="margin-top: 10px;display: inline-flex;">
        <span style="color: rgb(208, 47, 47);">注：</span><span style="margin-right: 20px;">方名颜色</span>
        <div style="width: 16px;height: 16px;background: rgba(100, 203, 96, 1);margin-top: 3px;border-radius: 3px;margin-right: 10px;"></div><span style="color: rgba(100, 203, 96, 1);margin-right: 40px;">一类来源(中医临床指南、国标、教材)</span>
        <div style="width: 16px;height: 16px;background: rgba(39, 114, 113, 1);margin-top: 3px;border-radius: 3px;margin-right: 10px;"></div><span style="color: rgba(39, 114, 113, 1);margin-right: 40px;">二类来源(名老中医经方、验方)</span>
        <div style="width: 16px;height: 16px;background: rgba(242, 85, 77, 1);margin-top: 3px;border-radius: 3px;margin-right: 10px;"></div><span style="color: rgba(242, 85, 77, 1);">三类来源(其它中医书籍、中医经验方)</span>
      </a-col>
    </a-row>
    <a-table :bordered="true" style="margin-top: 10px;" size="middle" class="gpws-pres-table" :default-expand-all-rows="true" :columns="columns" rowKey="id" :dataSource="((search.symptoms||[]).length > 0 ? (pres.filter(m => existsSymptoms(search.symptoms, m.symptoms))):pres)" :scroll="{y: init.height }">
      <div slot="name" slot-scope="text, record" :class="(record.group ==='A'?'gpws-pres-name-A':(record.group === 'B'?'gpws-pres-name-B':'gpws-pres-name-C'))">
        {{ record.name }}
      </div>
      <template slot="symptoms" slot-scope="text, record">
        <template v-if="(undefined != record.symptomDesc && null != record.symptomDesc && '' != record.symptomDesc)">
          <span v-html="parseSymptoms(search.symptoms, record.symptoms, record.symptomDesc)" style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;"/>
        </template>
        <span v-else>-</span>
      </template>
      <span slot="drugs" slot-scope="text, record" style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">
        {{ (record.drugs||[]).join("、") }}
      </span>
      <span slot="operate" slot-scope="text, record">
          <img src="../../assets/img/recipe.png"
               v-if="current.doctor && current.qualified && (record.drugs||[]).length > 0"
               style="cursor: pointer;user-select: none;" @click="recipeAction(record.id)"/>
        <img src="../../assets/img/detail.png" style="cursor: pointer;user-select: none;margin-left: 12px;"
             @click="detailAction(record.id)"/>
        <a-popconfirm placement="leftTop" title="是否确定加入我的方剂收藏?" v-if="current.doctor && current.qualified" ok-text="确定"
                      cancel-text="取消" @confirm="favoriteAction(record.id)">
          <img src="../../assets/img/s-favorite.png" style="cursor: pointer;user-select: none;margin-left: 12px;"/>
        </a-popconfirm>
        </span>
      <template slot="expandedRowRender" slot-scope="record">
        <a-row>
          <a-col span="6" style="display: inline-flex;"><span style="font-weight: bold;color: rgba(205, 86, 86, 1);min-width:50px;">治法:</span>{{ (record.treatments||[]).join(',') }}</a-col>
          <a-col span="14" style="display: inline-flex;"><span style="font-weight: bold;color: rgba(205, 86, 86, 1);min-width: 50px;">补充:</span>
            <div style="display: grid;">
              <span v-for="(item, i) in (record.complements||[])" :key="record.id+(i+1)">{{item}}</span>
            </div>
          </a-col>
          <a-col span="4">
            <a-row>
              <a-col style="text-align: center;"><span style="font-weight: bold;color: rgba(205, 86, 86, 1);">来源</span></a-col>
            </a-row>
            <a-row>
              <a-col style="text-align: center;">{{ record.source }}</a-col>
            </a-row>
          </a-col>
        </a-row>
      </template>
    </a-table>
    <prescription-detail ref="detail"/>
  </a-spin>
</template>

<script>

import Vue from 'vue'
import hevueImgPreview from 'hevue-img-preview';
Vue.use(hevueImgPreview);
import PrescriptionDetail from '@/components/prescription/PrescriptionDetail.vue';
export default {
  name: "SymptomTreatment",
  components: {
    PrescriptionDetail
  },
  data() {
    return {
      visible:false,
      loading:false,
      loadTip:'正在查询方剂信息....',
      init:{
        sex:'',
        year:'',
        month:'',
        months:'',
        symptomType:'GENERAL',
        height:'100%'
      },
      presSymptoms:[],
      conflicts:[],//已选症状的相悖症状集
      symptomTrees:[],
      symptoms:[],
      pres:[],//查询方剂结果
      trees:[],//查询的症状结果
      symptom:{},//当前选择的症状信息
      search:{
        symptom:'',//主症
        symptoms:[],//检索症状
        subSymptoms:[],//选择症状
      },
      columns:[{
        title: '证候',
        dataIndex: 'syndromes',
        align: 'center',
        key: 'syndrome',
        width: 100,
        customRender:(text, record, index) =>{
          return text == undefined || text == null || text == '' ? '-' : text;
        }
      },{
        title: '方名',
        dataIndex: 'name',
        align: 'center',
        key: 'name',
        width: 150,
        scopedSlots: { customRender: 'name'}
      },
        {
          title: '症状',
          key: 'symptoms',
          scopedSlots: { customRender: 'symptoms'}
        },
        {
          title: '药品',
          dataIndex: 'drugs',
          key: 'drugs',
          width: 300,
          scopedSlots: { customRender: 'drugs'}
        },
        {
          title: '操作',
          key: 'operate',
          align: 'center',
          width: 250,
          scopedSlots: { customRender: 'operate'}
        }]
    }
  },
  mounted() {
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.initialed();
    window.symptomDClickAction = this.symptomClickAction;
  },
  methods: {
    existsSymptoms:function (selected, symptoms) {
      if((selected||[]).length <= 0){
        return true;
      }else{
        for(let i=0; i< (selected||[]).length; i++){
          let existed = false;
          for(let n=0; n< (symptoms||[]).length; n++){
            if((selected||[])[i] == (symptoms||[])[n].name){
              existed = true;
              break;
            }
          }
          if(!existed){
            return false;
          }
        }
      }

      return true;
    },
    parseSymptoms:function (selected, symptoms, symptomDesc) {
      const self = this;
      let result = symptomDesc;
      let tags=[];
      (symptoms||[]).forEach(function (item, index) {
        result = result.replace(item.value, '{'+index+'}');
        if((selected||[]).includes(item.name)){
          tags.push('<label style="color: #f50;background: #e6f7ff;border-color: #91d5ff;margin-right: 8px;' +
              'padding: 0 7px;border: 1px solid #d9d9d9;border-radius: 4px;cursor: pointer;display: contents;" onclick="symptomDClickAction(\'' + item.name + '\')">' + item.value + '</label>');
        }else{
          tags.push('<label style="color: #1890ff;cursor: pointer;display: contents;" onclick="symptomDClickAction(\'' + item.name + '\')">' + item.value + '</label>');
        }
      });
      if((tags||[]).length > 0){
        result = this.formatString(result, tags);
      }
      return result;
    },
    detailAction: function (id) {
      this.$refs.detail.showModal(id);
    },
    favoriteAction: function (id) {
      const self = this;
      let params = {type: 'PRESCRIPTION', bizType: 'PRESCRIPTION', bizId: id};
      this.$axios.post('/api/clinic/favorite', params).then(function (res) {
        if (res.msg.flag == 0) {
          self.$message.success({content: '方剂收藏保存成功', duration: 2});
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
      });
    },
    symptomSearchAction:function(){
      if(undefined == this.search.symptom || null == this.search.symptom || '' == this.search.symptom){
        this.$message.error({content: '请先输入主症名,并选择主症.', duration: 2});
        return;
      }
      const self = this;
      let symptoms =[];
      if(undefined != this.search.symptoms && null != this.search.symptoms && this.search.symptoms.length > 0){
        this.search.symptoms.forEach(function (e) {
          let items = symptoms.filter(m => m == e);
          if(undefined == items || null == items || items.length <= 0){
            symptoms.push(e);
          }
        });
      }
      if(undefined != this.search.subSymptoms && null != this.search.subSymptoms && this.search.subSymptoms.length > 0){
        this.search.subSymptoms.forEach(function (e) {
          let items = symptoms.filter(m => m == e);
          if(undefined == items || null == items || items.length <= 0){
            symptoms.push(e);
          }
        });
      }
      this.pres =[];
      this.loading = true;
      this.$axios.get('/api/clinic/symptom/'+this.search.symptom+'/pres', {params:{symptom:symptoms.join(',')}}).then(function (res) {
        self.loading =false;
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz) {
          self.pres = res.biz;
          self.presFilterSymptoms();
        }
      }, function (res) {
        self.loading =false;
      });
    },
    symptomSearchClear:function(){
      this.conflicts = [];//已选症状的相悖症状集
      this.symptom={};//当前选择的症状信息
      this.pres = [];//查询方剂结果
      this.presSymptoms = [];
      this.search.symptoms = [];
      this.search.subSymptoms = [];
      this.conflictSymptom();
      this.presFilterSymptoms();
    },
    initialed: function () {
      const self = this;
      this.init.symptomType = 'GENERAL';
      this.symptomTrees = this.getLocalSymptoms('', this.init.sex, this.init.months);
      if((this.symptomTrees||[]).length <= 0){
        this.$axios.get('/api/clinic/position/symptoms', {params:{common:true}}).then(function (res) {
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            localStorage.setItem("symptoms", JSON.stringify(res.biz));
            self.symptomTrees = self.getLocalSymptoms('', self.init.sex, self.init.months);
          }
        }, function (res) {
        });
      }
      this.visible = true;
    },
    recipeAction:function(id){
      let symptoms = this.symptoms.filter(m => (this.search.subSymptoms||[]).includes(m.id)).map(m => m.name).join(',');
      this.$emit('clickit', {id:id, symptoms:symptoms});
      this.symptomSearchClear();
    },
    autoCompleteSymptomSelect:function(value){
      const self = this;
      this.trees=[];
      this.presSymptoms=[];
      this.conflicts=[];
      this.$axios.get('/api/clinic/symptom/'+this.search.symptom+'/symptoms', {params:{sex:this.init.sex, months:this.init.months, filtered:true}}).then(function (res) {
        self.trees=[];
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
          self.trees = res.biz;
          res.biz.forEach(function(e){
            if(undefined != e.children && null != e.children && e.children.length > 0){
              e.children.forEach(function (m) {
                self.presSymptoms.push(m.id);
              });
            }
          });
        }
      }, function (res) {
      });
      this.symptomSearchAction();
    },
    autoCompleteMainSymptomSearch:function (value){
      const self = this;
      this.symptoms=[];
      if(undefined != value && null != value && '' != value && value.trim().length > 0){
        this.$axios.get('/api/clinic/position/symptoms', {params:{keyword:value.trim(), sex:this.init.sex, months:this.init.months, common:true}}).then(function (res) {
          self.symptoms =[];
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            (res.biz.filter(m => (m.children||[]).length >0)||[]).forEach(function (e) {
              e.children.forEach(function (m) {
                self.symptoms.push(m);
              });
            });
          }
        }, function (res) {
        });
      }
    },
    autoCompleteSymptomSearch:function(value){
      const self = this;
      if(undefined == this.search.symptom || null == this.search.symptom || '' == this.search.symptom){
        this.$message.error({content: '请先输入主症名,并选择主症.', duration: 2});
        return;
      }

      this.symptoms=[];
      if(undefined != value && null != value && '' != value && value.trim().length > 0){
        this.$axios.get('/api/clinic/symptom/'+this.search.symptom+'/symptoms', {params:{symptom:this.search.symptoms.join(','), keyword:value, sex:this.init.sex, months:this.init.months}}).then(function (res) {
          self.symptoms =[];
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            (res.biz.filter(m => (m.children||[]).length >0)||[]).forEach(function (e) {
              e.children.forEach(function (m) {
                self.symptoms.push(m);
              });
            });
          }
        }, function (res) {
        });
      }
    },
    //子症状单选
    autoCompleteSymptomDeselect:function (value) {
      this.search.subSymptoms.splice(this.search.subSymptoms.indexOf(value), 1);
      this.clearSymptoms(value);
    },
    //子症状单选
    symptomClickAction:function(id){
      const self = this;
      this.symptom = null;
      let items = self.search.subSymptoms.filter(n => n == id);
      if(undefined == items || null == items || items.length <= 0){
        this.trees.forEach(function (e) {
          if(undefined != e.children && null != e.children && e.children.length > 0){
            let symptoms = e.children.filter(m => m.id == id);
            if(undefined != symptoms && null != symptoms && symptoms.length > 0){
              self.symptom = symptoms[0];
            }
          }
        });

        if(undefined == this.symptom || null == this.symptom){
          this.$axios.get('/api/clinic/symptom/'+id).then(function (res) {
            if (res.msg.flag == 0 && undefined != res.biz && null != res.biz) {
              self.symptom = res.biz;
              self.search.subSymptoms.push(res.biz.id);
              self.appendSymptoms(res.biz);
            }
          }, function (res) {
          });
        }else{
          this.search.subSymptoms.push(this.symptom.id);
          this.appendSymptoms(this.symptom);
        }
      }else{
        this.search.subSymptoms.splice(this.search.subSymptoms.indexOf(id), 1);
        this.clearSymptoms(id);
      }
    },
    presFilterSymptoms:function(){
      const self = this;
      if((this.pres||[]).length > 0){
        this.presSymptoms=[];
        let symptoms = new Set();
        (this.pres.filter(m => self.existsSymptoms(self.search.symptoms, m.symptoms))||[]).forEach(function (e) {
          (e.symptoms||[]).forEach(function (n) {
            symptoms.add(n.name);
          });
        });
        this.presSymptoms = Array.from(symptoms);
      }
    },
    //添加至查询框
    appendSymptoms:function(symptom){
      let symptoms = this.symptoms.filter(m => m.id == symptom.id);
      if(undefined == symptoms || null == symptoms || symptoms.length <= 0){
        this.symptoms.push(symptom);
      }
      let items = this.search.symptoms.filter(n => n == symptom.id);
      if(undefined == items || null == items || items.length <= 0){
        this.search.symptoms.push(symptom.id);
        this.conflictSymptom();
        this.presFilterSymptoms();
      }
    },
    //清除
    clearSymptoms:function (id) {
      let items = this.search.symptoms.filter(n => n == id);
      if(undefined != items && null != items && items.length > 0){
        this.search.symptoms.splice(this.search.symptoms.indexOf(id), 1);
      }
      this.conflictSymptom();
      this.presFilterSymptoms();
    },
    //相悖症状处理
    conflictSymptom:function(){
      const self = this;
      if(undefined != this.search.subSymptoms && null != this.search.subSymptoms && this.search.subSymptoms.length > 0){
        let conflicts = new Set();
        this.search.subSymptoms.forEach(function (e) {
          if(undefined != e.conflicts && null != e.conflicts && e.conflicts.length > 0){
            e.conflicts.forEach(function (e) {
              conflicts.add(e);
            });
          }
        });
        self.conflicts = Array.from(conflicts);
      }
    },
    autoCompleteSymptomFocus:function(){
      this.symptoms=[];
    },
    showFullImg: function (url) {
      this.$hevueImgPreview({
        url: url,
        mainBackground: 'rgba(0, 0, 0, .5)', // 整体背景颜色
      });
    },
    symptomTypeChange:function(type){
      this.init.symptomType = type;
    },
    children:function (e) {
      const self = this;
      let result =[];
      if(undefined != e.children && null != e.children && e.children.length > 0){
        e.children.forEach(function (m){
          result.push({title:m.name, value:m.id, key:m.id, children:self.children(m)});
        });
      }
      return result;
    }
  }
}
</script>

<style scoped>
.gpws-m-b-12 {
  margin-bottom: 12px !important;
}

.gpws-symptom-left-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
  color: white;
}

.gpws-symptom-right-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
  color: white;
}

.gpws-symptom-left-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
}

.gpws-symptom-right-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
}

.gpws-symptom-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  color: white;
}

.gpws-symptom-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
}

.gpws-symptom-postion {
  line-height: 40px !important;
  font-weight: bold !important;
  font-size: 14px !important;
  text-align: center !important;
  color: rgba(208, 47, 47, 1) !important;
}

.gpws-symptom-span {
  cursor: pointer;
  user-select: none;
}

.gpws-symptom-span:hover {
  border: 2px solid rgba(39, 146, 194, 0.5) !important;
  background-color: #ffffff;
  border-radius: 15px !important;
  color: rgba(0, 0, 0, 0.65) !important;
  padding: 6px !important;
}

.gpws-symptom-span-selected {
  background: #2792c2 !important;
  color: #ffffff !important;
  border-radius: 15px !important;
  padding: 6px !important;
}
</style>
